import { SelectedOption } from "./selectedOption.model";

// mogla bit enumeracija da poboljsa kod
export const WARNING_TYPE_OPTIONS: SelectedOption[] = [
    {
        value: 1,
        label: 'Dan pre dospeća'
    },
    {
        value: 2,
        label: 'Dan nakon dospeća'
    },
    {
        value: 3,
        label: 'Opomena pred isključenje'
    }
];
